import CheckoutOptions from "./CheckoutOptions";
import { RetailerConnect } from "./RetailerConnect";
import CheckoutOptionsV2 from "./CheckoutOptionsV2";
import { useGuestCheckoutEnabled } from "../useGuestCheckout";

const AccountForCheckout = () => {
  const { enabledGuestCheckout, experimentEnabled } = useGuestCheckoutEnabled();

  if (!enabledGuestCheckout) {
    return <RetailerConnect />;
  }

  if (experimentEnabled) {
    return <CheckoutOptionsV2 />;
  }

  return <CheckoutOptions />;
};

export default AccountForCheckout;
